<template>
    <div>
        <b-img
            v-if="vehicleImageUrl && !errorFound"
            class="configured-img"
            :src="vehicleImageUrl"
            :alt="vehicleName"
            fluid
            @error="onError"
        />
        <body-style-icon v-else :id="bodyStyle" />
    </div>
</template>

<style scoped lang="scss">
.configured-img {
    max-width: 250px;
}

i {
    font-size: 60px;
    margin: 40px 0;
    display: block;
}
</style>

<script>
import BodyStyleIcon from "Components/BodyStyleIcon";

export default {
    components: { BodyStyleIcon },

    props: {
        vehicleImageUrl: {
            type: String,
            required: false,
            default: null
        },
        vehicleName: {
            type: String,
            required: false,
            default: null
        },
        bodyStyle: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            errorFound: false
        };
    },

    methods: {
        onError() {
            console.error("Missing Image");
            this.errorFound = true;
        }
    }
};
</script>
